import { render, staticRenderFns } from "./chart-register-info.vue?vue&type=template&id=176c26d2&scoped=true&lang=pug&"
import script from "./chart-register-info.vue?vue&type=script&lang=ts&"
export * from "./chart-register-info.vue?vue&type=script&lang=ts&"
import style0 from "./chart-register-info.vue?vue&type=style&index=0&id=176c26d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c26d2",
  null
  
)

export default component.exports